import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginService } from './login/login.service';
import { User } from './models/user';

@Injectable({
  providedIn: 'root'
})
export class SSEService {
  public connectionState$ = new BehaviorSubject<string>('connecting');
  public userCreated$ = new Subject<User>();
  private eventSource = new EventSource(`${environment.serverURL}${environment.ssePath}/stream`);

  constructor(private loginService: LoginService, private ngZone: NgZone) {

    this.connectionState$.next('connecting');

    this.eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log('Neues Event via SSE:', data);

      this.ngZone.run(() => {
        this.connectionState$.next('message');
      });
    };

    this.eventSource.onopen = (event) => {
      this.ngZone.run(() => {
        this.connectionState$.next('connected');
      });
    }

    this.eventSource.onerror = (event) => {
      this.ngZone.run(() => {
        this.connectionState$.next('unavailable');
      });
    }
  }

  disconnect() {
    this.eventSource.close();
  }
}
